import { render, staticRenderFns } from "./ZoomButtons.vue?vue&type=template&id=cf42cd86&scoped=true&"
import script from "./ZoomButtons.vue?vue&type=script&lang=ts&"
export * from "./ZoomButtons.vue?vue&type=script&lang=ts&"
import style0 from "./ZoomButtons.vue?vue&type=style&index=0&id=cf42cd86&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf42cd86",
  null
  
)

export default component.exports